import { Student, Lesson } from "@/types/tutor";
import StudentList from "./StudentList";
import LessonList from "./LessonList";
import { useId, useState } from "react";

interface ClassroomInfoProps {
  students: Student[];
  lessons: Lesson[];
  classroomId: string;
  getAnalyticsHref?: (lessonId: number, lessonName: string) => string;
  onLessonUnassign?: (lessonId: number) => void;
}

const ClassroomInfo = ({
  students,
  lessons,
  classroomId,
  getAnalyticsHref,
  onLessonUnassign,
}: ClassroomInfoProps) => {
  const [tab, setTab] = useState("lessons");
  const id = useId();
  return (
    <div className="et-group-content">
      <div className="et-group-tabs" role="tablist" aria-label="Group content">
        {["lessons", "students"].map((name) => (
          <button
            key={name}
            type="button"
            role="tab"
            id={`${id}-${name}`}
            aria-selected={tab === name}
            aria-controls={`${id}-panel`}
            tabIndex={tab === name ? 0 : -1}
            onClick={() => setTab(name)}
            onKeyDown={(event) => {
              if (
                ["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)
              ) {
                event.preventDefault();
                const next =
                  event.key === "Home"
                    ? "lessons"
                    : event.key === "End"
                      ? "students"
                      : name === "lessons"
                        ? "students"
                        : "lessons";
                setTab(next);
                document.getElementById(`${id}-${next}`)?.focus();
              }
            }}
          >
            {name === "lessons" ? "Lessons" : "Students"}
          </button>
        ))}
      </div>
      <div
        role="tabpanel"
        id={`${id}-panel`}
        aria-labelledby={`${id}-${tab}`}
        tabIndex={0}
      >
        {tab === "students" ? (
          <div className="et-group-students">
            <StudentList students={students} classroomId={classroomId} />
          </div>
        ) : (
          <LessonList
            lessons={lessons}
            classroomId={classroomId}
            getAnalyticsHref={getAnalyticsHref}
            onUnassign={onLessonUnassign}
          />
        )}
      </div>
    </div>
  );
};

export default ClassroomInfo;
